import {
  CreateButton,
  ExportButton,
  TopToolbar,
  sanitizeListRestProps,
  useListContext,
} from "react-admin";
import React, { useContext, useMemo } from "react";
import { WorkflowContext, useRoles } from "ra-friendsofbabba";

import { cloneElement } from "react";

const Actions = ({ canExport = true, children, ...props }) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const {
    currentSort,
    resource,
    displayedFilters,
    filterValues,
    basePath,
    showFilter,
    total,
  } = useListContext();
  const { getWorkflow } = useContext(WorkflowContext);
  const workflow = getWorkflow(resource);
  const roles = useRoles();
  const canCreate = useMemo(
    () => !workflow || workflow.canCreate(roles),
    [workflow, roles]
  );
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      {canCreate && <CreateButton basePath={basePath} />}

      {canExport && (
        <ExportButton
          disabled={total === 0}
          resource={resource}
          sort={currentSort}
          filterValues={filterValues}
          maxResults={maxResults}
        />
      )}
      {React.Children.map(
        children,
        (child) =>
          React.isValidElement(child) &&
          cloneElement(child, {
            disabled: total === 0,
            resource: resource,
            sort: currentSort,
            filterValues: filterValues,
            maxResults: maxResults,
          })
      )}
    </TopToolbar>
  );
};

export default Actions;
